export const gradientText = {
  background: 'linear-gradient(45deg, #00CECF, #03FF75)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export const primaryHeader = {
  fontSize: '20px',
  fontWeight: 'bold',
};

export const secondarySentence = {
  // color: 'gray',
  // fontSize: '.9rem',
  color: '#878787',
  overflow: 'auto',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'justify',
};

export const guidelineHeader = {
  mb: 1,
  fontWeight: 'bold',
  fontSize: '1.3rem',
};

export const whiteScondarySentence = {
  color: '#ffffff',
  overflow: 'auto',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'justify',
};

export const centerSecondarySentence = {
  color: '#878787',
  overflow: 'auto',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'center',
};
